import { z } from 'zod';

export const equipmentDetectionSchema = z.object({
  equipmentId: z.string().nullish(),
  classId: z.number().nullish(),
});

export type TEquipmentDetectionSchema = z.infer<
  typeof equipmentDetectionSchema
>;
